import { useEffect, useId, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Icon } from '../../../../../common/html/icon'
import { SelectCustom } from '../../../../../common/selectCustom'
import EventEmitter, {
  SHOW_SELECT_CUSTOM,
} from '../../../../../helpers/EventEmitter'
import { selectCurrentPortfolio as selectCurrentPortfolioInPortfolioInsights } from '../../../../../portfolioInsights/common/popupCompanyList/store/slice'
import { filterDropList, getLabelAndValuePortfolio } from '../helper'
import classes from '../index.module.scss'
import {
  changeCurrentPortfolio,
  changeNamePortfolioActive,
  selectAllPortfolio,
  selectCurrentPortfolio as selectCurrentPortfolioInDynamic,
} from '../store/slice'

const DROP_DOWN_MIN_WIDTH = 284

const InputPortfolio = () => {
  const dispatch = useDispatch()
  const id = useId()
  const [inputValue, setInputValue] = useState('')

  const currentPortfolio = useSelector(selectCurrentPortfolioInDynamic)
  const allPortfolio = useSelector(selectAllPortfolio)
  const portfolioByRedirect = useSelector(
    selectCurrentPortfolioInPortfolioInsights,
  )

  useEffect(() => {
    handleClickOutside()
  }, [allPortfolio])

  const dropList = useMemo(() => {
    return filterDropList(allPortfolio, inputValue)
  }, [inputValue])

  const chooseItem = ({ label, value }) => {
    dispatch(changeCurrentPortfolio(value))
    dispatch(changeNamePortfolioActive(label))
    setInputValue(label)
  }

  const handleClickOutside = () => {
    const label = allPortfolio.find(
      (item) => item.value === currentPortfolio,
    )?.label
    setInputValue(label ?? '')
  }

  const onClick = (e) => {
    e.stopPropagation()
    EventEmitter.dispatch(SHOW_SELECT_CUSTOM, { id })
  }

  useEffect(() => {
    const values = Object.values(portfolioByRedirect)
    if (values.every((value) => !value)) return

    const { label, value } = getLabelAndValuePortfolio(
      portfolioByRedirect,
      allPortfolio,
    )

    chooseItem({ label, value })
  }, [portfolioByRedirect, allPortfolio])

  return (
    <div className={`dFlex ${classes.mt12}`}>
      <SelectCustom
        id={id}
        activeItem={{ value: currentPortfolio }}
        chooseItem={chooseItem}
        data={dropList}
        style={{ backgroundColor: '#FFF' }}
        className={classes.selectCustom}
        handleClickOutside={handleClickOutside}
        customWidthDropdown={DROP_DOWN_MIN_WIDTH}
        renderActiveItem={() => {
          return (
            <div className="w100 dFlex">
              <Icon
                className={['icon-search', classes.iconSearch].join(' ')}
                style={{ color: '#9C9C9C' }}
              />
              <input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onFocus={() => setInputValue('')}
                className={classes.inputCustom}
                placeholder={I18n.t('dynamicReport.ENTER_PORTFOLIO_NAME')}
                onClick={onClick}
              />
            </div>
          )
        }}
      />
    </div>
  )
}

export default InputPortfolio
